import React, { useEffect, useState } from 'react';

import './NewPostForm.scss';

import networker from '../../services/networking';

import { Form } from '../Form';
import { Input }  from '../basic/Input/Input';
import { Button } from '../basic/Button/Button';
import { ButtonGroup } from '../ButtonGroup/ButtonGroup';
import { ContentPermanentHint } from '../ContentPermanentHint/ContentPermanentHint';
import { SecondsCounter } from '../SecondsCounter/SecondsCounter';
import { PostResponse } from '../../types/models/posts';

interface INewPostFormProps {
  hideHint?: boolean;
  isDemo?: boolean;
  addPostToState: (newPost: PostResponse) => void;
  defaultValue?: string;
}

export function NewPostForm({ hideHint, isDemo, addPostToState, defaultValue }: INewPostFormProps) {
  const [isCancelTimerShown, setIsCancelTimerShown] = useState(false);
  const [textValue, setTextValue] = useState('');

  useEffect(() => {
    if (defaultValue) {
      setTextValue(defaultValue);
    }
  }, []);
  
  const onTimerEnd = 
    isDemo
      ? () => {
          setIsCancelTimerShown(false);
          alert('This is demo. But in real life scenario post will be created.');
        }
      : () => {
        setIsCancelTimerShown(false);
        networker.createPost({ text: textValue })
          .then((post: PostResponse | undefined) => {
            if (!post) {
              return null;
            }
            setTextValue('');
            addPostToState(post);
          })
          .catch(console.log);
      };

  const onTimerCancel = () => {
    setIsCancelTimerShown(false);
  };
  
  const onPostButton = () => {
    setIsCancelTimerShown(true);
  };

  return (
    <div className='NewPostForm'>
      {
        hideHint
          ? null
          : <ContentPermanentHint />
      }
      <Form>

        <Input
          inputType='textarea'
          label='Your post'
          maxLength={500}
          value={ textValue }
          setValue={ setTextValue }
          isDisabled={ isCancelTimerShown }
        />

        <ButtonGroup>
          <Button
            isDisabled={ textValue.length === 0 || isCancelTimerShown }
            text='Post'
            buttonType='main'
            handleClick={ onPostButton }
          />
        </ButtonGroup>

      </Form>
      {
        isCancelTimerShown
          ? <SecondsCounter onSend={ onTimerEnd } onCancel={ onTimerCancel } />
          : null
      }
    </div>
  );
}
